import React, { PureComponent } from 'react';
import { fromJS } from 'immutable';

import { Dropdown } from 'semantic-ui-react';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './SimpleTimePicker.css';
const cx = classNames.bind(styles);

class SimpleTimePicker extends PureComponent {
  constructor(props) {
    super(props);

    this.handleHourOnChange = this.handleHourOnChange.bind(this);
  }

  handleHourOnChange = (e, data) => {
    const { name, onChange: handleOnChange } = this.props;
    const timeData = { hour: undefined, minute: undefined, second: undefined };
    timeData[data.name] = data.value;

    handleOnChange(name, timeData);
  };

  render() {
    const { handleHourOnChange } = this;
    const { className, titleClassName, titleText, timeObj, ...rest } = this.props;

    const listHours = [];
    for (let i = 0; i < 24; i++) {
      listHours.push({ key: i, text: common.fitTwoDigit(i), value: i.toString() });
    }
    const listMinutes = [];
    for (let i = 0; i < 60; i++) {
      listMinutes.push({ key: i, text: common.fitTwoDigit(i), value: i.toString() });
    }
    const listSeconds = listMinutes;

    return (
      <div className={cx('simple-time-picker-box', className)}>
        <div className={cx('simple-time-picker-title', titleClassName)}>{titleText}</div>
        <div className={cx('simple-time-picker-select')}>
          <div className={cx('simple-time-picker-part', rest.hideHour ? 'display-none' : '')}>
            <Dropdown
              basic
              selection
              compact
              scrolling
              name="hour"
              // placeholder={timeObj.hour || '01'}
              defaultValue={String(timeObj[rest.name].hour) || rest.defaultValueHour || ''}
              // value={String(timeObj[rest.name].hour) || '1'}
              className={cx('simple-time-picker-hour')}
              onChange={handleHourOnChange}
              options={listHours}
            />
          </div>
          <div className={cx('simple-time-picker-part', rest.hideMinute ? 'display-none' : '')}>
            <Dropdown
              basic
              selection
              compact
              scrolling
              name="minute"
              // placeholder={timeObj.minute || '01'}
              defaultValue={String(timeObj[rest.name].minute) || rest.defaultValueMinute || ''}
              // value={String(timeObj[rest.name].minute) || '1'}
              className={cx('simple-time-picker-hour')}
              onChange={handleHourOnChange}
              options={listMinutes}
            />
          </div>
          <div className={cx('simple-time-picker-part', rest.hideSecond ? 'display-none' : '')}>
            <Dropdown
              selection
              compact
              scrolling
              name="second"
              // placeholder={rest.placeholderSecond || ''}
              // defaultValue={rest.defaultValueSecond || ''}
              className={cx('simple-time-picker-hour')}
              onChange={handleHourOnChange}
              options={listSeconds}
            />
            <div className={titleClassName}>{}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default SimpleTimePicker;



// WEBPACK FOOTER //
// ./src/script/components/common/SimpleTimePicker.js